export function getIntegrationsRoutes() {
  return [
    {
      path: "/integrations",
      name: "integrations",
      component: () => import("./views/IntegrationCenterIframeView.vue"),
    },
  ]
}
